<template>
  <div class="container">
      <p style="text-align:center">{{row.bcr_request_balance}}</p>
  </div>
</template>

<script>
  export default {
    props: {
      row: {
        type: Object
      }
    },
    
  }
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  user-select:none;
  
}
</style>